// @ts-nocheck
import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { BackOrderCollectionModel } from "@store/Framework/Types/ApiModels";

export interface GetBackOrdersApiParameter extends ApiParameter, HasPagingParameters {}

export interface UpdateBackOrderApiParameter {
    id: string;
    isCancelled: boolean;
    newQuantity: number;
}

const backOrdersUrl = "/api/v1/BackOrders";

export async function getBackOrders(parameter: GetBackOrdersApiParameter): Promise<BackOrderCollectionModel> {
    return get<BackOrderCollectionModel>(`${backOrdersUrl}/current`, parameter);
}

export async function updateBackOrder(parameter: UpdateBackOrderApiParameter) {
    return post<UpdateBackOrderApiParameter>(`${backOrdersUrl}/modify`, parameter);
}
